import { Col, Container, Row, Stack } from "react-bootstrap"

const HireLaravelDeveloperContent = () => {
    return (
        <Container className="hire-content-container">
            <Row>
                <Col>
                    <Stack className="hire-content-info">
                        <h2>
                            Hire Expert Laravel Developers for Robust Web Solutions
                        </h2>
                        <p>
                            Need scalable, secure, and high-performing web applications? Hire our experienced Laravel developers who specialize in building custom, maintainable solutions using Laravel’s powerful MVC architecture and cutting-edge features.
                        </p>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>
                            Why Hire Laravel Developers from Us?
                        </h2>
                        <ul>
                            <li>
                                <b>Deep Laravel Expertise</b>
                                <p>
                                    Our developers are highly skilled in Laravel and its ecosystem, including Eloquent ORM, Blade templating, Laravel Mix, and Artisan CLI, enabling rapid and clean development.
                                </p>
                            </li>
                            <li>
                                <b>Clean & Scalable Architecture</b>
                                <p>
                                    We follow SOLID principles, modular structure, and Laravel best practices to ensure your application is easy to maintain and scale as your business grows.
                                </p>
                            </li>
                            <li>
                                <b>Custom Web Application Development</b>
                                <p>
                                    Whether it's a SaaS product, a multi-tenant system, or a business portal — our Laravel developers build tailor-made solutions aligned with your goals.
                                </p>
                            </li>
                            <li>
                                <b>eCommerce Development with Laravel</b>
                                <p>
                                    We develop full-fledged eCommerce platforms using Laravel or packages like Bagisto and Aimeos, complete with product management, order handling, and secure payment integration.
                                </p>
                            </li>
                            <li>
                                <b>RESTful API Development</b>
                                <p>
                                    Need APIs for mobile apps or third-party integrations? We build fast and secure RESTful APIs using Laravel Passport or Sanctum for authentication.
                                </p>
                            </li>
                            <li>
                                <b>Laravel Package Development</b>
                                <p>
                                    We can create reusable Laravel packages or modules that speed up development and improve code organization in large-scale applications.
                                </p>
                            </li>
                            <li>
                                <b>Legacy Code Refactoring</b>
                                <p>
                                    We modernize outdated PHP applications by migrating them to Laravel, ensuring better performance, security, and maintainability.
                                </p>
                            </li>
                            <li>
                                <b>Flexible Hiring Models</b>
                                <p>
                                    Hire Laravel developers on a full-time, part-time, or hourly basis depending on your project requirements and deadlines.
                                </p>
                            </li>
                        </ul>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>
                            Our Laravel Development Services Include:
                        </h2>
                        <ul>
                            <li>Custom Laravel Web Application Development</li>
                            <li>eCommerce Development using Laravel</li>
                            <li>Laravel API Development & Integration</li>
                            <li>Laravel SaaS/Multi-Tenant App Development</li>
                            <li>Migration to Laravel from Legacy Systems</li>
                            <li>Laravel Package/Module Development</li>
                            <li>Performance Optimization & Code Refactoring</li>
                            <li>Ongoing Maintenance & Support</li>
                        </ul>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>
                            Let’s Build Your Laravel Application the Right Way
                        </h2>
                        <p>
                            Our Laravel developers bring years of experience and a problem-solving mindset to every project. From prototyping to production, we ensure your application is fast, secure, and easy to scale. Reach out now for a free consultation and project quote.
                        </p>
                    </Stack>
                </Col>
            </Row>
        </Container>
    )
}

export default HireLaravelDeveloperContent;
